import { Pipe, PipeTransform, QueryList } from '@angular/core';
import { TemplateDirective } from '@fleet-beat/core';

@Pipe({
  name: 'combineTemplates',
})
export class CombineTemplatesPipe implements PipeTransform {
  transform(
    templates: TemplateDirective<object>[] | QueryList<TemplateDirective<object>>,
    additionalTemplates: TemplateDirective<object>[],
  ): TemplateDirective<object>[] {
    return [...(templates || []), ...(additionalTemplates || [])];
  }
}
